import { createSlice } from '@reduxjs/toolkit';
import { takeOne } from '../../helpers/store';

import { ReducerState } from '../configure-store';
import { AssessmentQuestion } from '../../types/assessment-question';
import { listAssessmentQuestion, updateAssessmentQuestion } from '../thunks/assessment-question-thunks';

export interface AssessmentQuestionState extends ReducerState {
    data: AssessmentQuestion[];
}

const initialState: AssessmentQuestionState = {
    error: '',
    loading: 'none',
    requestIds: [],
    data: [],
};

const slice = createSlice({
    name: 'assessment-question',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(listAssessmentQuestion.pending, takeOne.pendingActionCase)
            .addCase(listAssessmentQuestion.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listAssessmentQuestion.rejected, takeOne.rejectedActionCase)

            .addCase(updateAssessmentQuestion.pending, takeOne.pendingActionCase)
            .addCase(updateAssessmentQuestion.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateAssessmentQuestion.rejected, takeOne.rejectedActionCase);
    },
});

export const {} = slice.actions;

export default slice.reducer;
